<template>
	<Route :breadcrumbs="breadcrumbs">
		<template slot="title">
			Projects
		</template>
		<router-view />
	</Route>
</template>

<script>
import Route from '@/views/layouts/Route';

export default {
	components: {
		Route,
	},
	data() {
		return {
			breadcrumbs: [
				{ text: 'Dashboard', to: '/' },
				{ text: 'Projects', to: '/projects' },
			],
		};
	},
	// Single Project Guard
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			if (vm.$store.get('projects/isSingleProject')) {
				vm.$router.push({ name: 'ReportsList', params: { projectId: vm.$store.get('projects/active').first().id } });
			}
		});
	},
};
</script>
